import React from 'react'
import { BsFillLightningChargeFill } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import styles from './NoEnoughCredits.module.css'

function NoEnoughCredits() {
  return (
    <div className={styles.noCreditsContainer}>
      <div className={styles.noCreditsText}>No Enough Credits</div>
        


       <p><Link to='/subscription-form'>renew credits <BsFillLightningChargeFill/></Link></p> 
    </div>
  )
}

export default NoEnoughCredits